var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C15.5795 28 16.8718 26.7077 16.8718 25.1282H11.1282C11.1282 26.7077 12.4061 28 14 28ZM22.6154 19.3846V12.2051C22.6154 7.79692 20.2605 4.10667 16.1538 3.13026V2.15385C16.1538 0.962051 15.1918 0 14 0C12.8082 0 11.8462 0.962051 11.8462 2.15385V3.13026C7.72512 4.10667 5.38461 7.78256 5.38461 12.2051V19.3846L2.51282 22.2564V23.6923H25.4872V22.2564L22.6154 19.3846Z",
    fill: "#E3ECF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDark);
export default __webpack_public_path__ + "static/media/notification_dark.6bed5a58d23f9e5eefafb14e232b2bb0.svg";
export { ForwardRef as ReactComponent };